<template>
  <div id="app">
    
    <router-view/>
  </div>
</template>
<script>
export default {
    data:()=>({
         enpoint : 'https://api.nadwah.live/api',
         endpoint : 'https://api2.nadwah.live'
    })
}
</script>
<style>
   .container {
            max-width: 100%;
            width: 640px;
            margin: 0 auto;
        }

        body {
            background: #f7f8fa;
        }

        [v-cloak]>* {
            display: none
        }

        [v-cloak]::before {
            content: "loading…"
        }

        pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
    font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,'PingFang SC','Hiragino Sans GB','Microsoft Yahei',sans-serif;
}   

@media only screen and (max-width: 768px) {
            .padding-on-computer{
                padding : 16px;
            }
        }


</style>
